/**
 * employeeDocumentMasterApi.js
 * ----------------------------
 * API client for Employee Document Master (EmployeeDocumentMaster) using createMasterApiClient.
 * Connects directly to FastAPI backend /employee-document-master/ endpoints.
 */
import api from '../../../../api/client';
import { createMasterApiClient } from '../../common/masterApiFactory';

export const employeeDocumentMasterClient = createMasterApiClient('employee-document-master');

export const listDocumentTemplates = (params) => employeeDocumentMasterClient.list(params);
export const getDocumentTemplateDetail = (id) => employeeDocumentMasterClient.getById(id);
export const createDocumentTemplate = (data) => employeeDocumentMasterClient.create(data);
export const updateDocumentTemplate = (id, data) => employeeDocumentMasterClient.update(id, data);
export const archiveDocumentTemplate = (id) => employeeDocumentMasterClient.archive(id);
export const deleteDocumentTemplate = (id) => employeeDocumentMasterClient.remove(id);
export const getDocumentTemplateOptions = () => employeeDocumentMasterClient.getDropdownOptions();

export const getDocumentCategories = async () => {
  const response = await api.get('/employee-document-master/categories');
  return response.data;
};

export const getAvailableTokens = async () => {
  const response = await api.get('/employee-document-master/tokens');
  return response.data;
};
